import { Box } from '@mui/material'

interface BrandMarkProps {
  size?: number
  borderRadius?: number
}

export function BrandMark({ size = 36, borderRadius = 2 }: BrandMarkProps) {
  const large = size >= 48

  return (
    <Box
      aria-hidden
      sx={{
        width: size,
        height: size,
        borderRadius,
        bgcolor: 'primary.main',
        color: 'primary.contrastText',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        boxShadow: (t) =>
          t.palette.mode === 'dark'
            ? large
              ? '0 4px 16px rgba(0,0,0,0.45)'
              : '0 1px 6px rgba(0,0,0,0.4)'
            : large
              ? '0 4px 14px rgba(15,118,110,0.28)'
              : '0 1px 4px rgba(15,118,110,0.25)',
      }}
    >
      <Box
        component="span"
        sx={{
          fontFamily:
            '"Geeza Pro", "Damascus", "Al Bayan", "Noto Naskh Arabic", "Amiri Quran", "Traditional Arabic", serif',
          fontSize: size * 0.86,
          fontWeight: 500,
          lineHeight: 1,
          transform: 'translateY(-4%)',
          direction: 'rtl',
        }}
      >
        ق
      </Box>
    </Box>
  )
}

